/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as UserAgreementRouteImport } from './routes/user-agreement'
import { Route as ArticleIdRouteImport } from './routes/article.$id'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const UserAgreementRoute = UserAgreementRouteImport.update({
  id: '/user-agreement',
  path: '/user-agreement',
  getParentRoute: () => rootRouteImport,
} as any)
const ArticleIdRoute = ArticleIdRouteImport.update({
  id: '/article/$id',
  path: '/article/$id',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/contact': typeof ContactRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/user-agreement': typeof UserAgreementRoute
  '/article/$id': typeof ArticleIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/contact': typeof ContactRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/user-agreement': typeof UserAgreementRoute
  '/article/$id': typeof ArticleIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/contact': typeof ContactRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/user-agreement': typeof UserAgreementRoute
  '/article/$id': typeof ArticleIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/contact'
    | '/privacy'
    | '/terms'
    | '/user-agreement'
    | '/article/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/contact'
    | '/privacy'
    | '/terms'
    | '/user-agreement'
    | '/article/$id'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/contact'
    | '/privacy'
    | '/terms'
    | '/user-agreement'
    | '/article/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  ContactRoute: typeof ContactRoute
  PrivacyRoute: typeof PrivacyRoute
  TermsRoute: typeof TermsRoute
  UserAgreementRoute: typeof UserAgreementRoute
  ArticleIdRoute: typeof ArticleIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user-agreement': {
      id: '/user-agreement'
      path: '/user-agreement'
      fullPath: '/user-agreement'
      preLoaderRoute: typeof UserAgreementRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/article/$id': {
      id: '/article/$id'
      path: '/article/$id'
      fullPath: '/article/$id'
      preLoaderRoute: typeof ArticleIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  ContactRoute: ContactRoute,
  PrivacyRoute: PrivacyRoute,
  TermsRoute: TermsRoute,
  UserAgreementRoute: UserAgreementRoute,
  ArticleIdRoute: ArticleIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
